<template>
  <div>
    <v-card elevation="0" class="pa-5">
      <div class="d-flex align-center mb-3">
        <strong>Web Hook</strong>
        <v-spacer />
        <v-btn size="small" color="primary" @click="webHookCardEmit()">
          <v-icon icon="mdi-arrow-left" start></v-icon> Back
        </v-btn>
      </div>

      <v-divider />

      <div class="d-flex mt-3">
        <v-select
          density="compact"
          variant="outlined"
          v-model="webHookService"
          :items="webHookServiceItems"
          item-title="module_name"
          item-value="module_end_point"
          return-object
          label="Web Hook Services"
          class=""
        />
        <v-spacer />

        <div class="d-flex align-center">
          <strong>Organization API Key:</strong>
          <span class="ml-2">
            {{
              $store.getters.get_current_user_details?.organization_details
                ?.organization_api_key
                ? `${$store.getters.get_current_user_details.organization_details.organization_api_key?.slice(
                    0,
                    20
                  )}...`
                : "N/A"
            }}
          </span>

          <v-btn
            v-if="
              $store.getters.get_current_user_details?.organization_details
                ?.organization_api_key
            "
            size="small"
            class="ml-3"
              variant="flat"
           color="primary"
            @click="copyApiKey"
          >
            <v-icon size="small" color="white">mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </div>

      <div
        style="width: 100%; background: black; color: white"
        class="pa-5 mt-4"
      >
        <div class="d-flex align-center">
          <strong>Endpoint:</strong>
          <span class="ml-2">{{
            webHookService?.module_end_point || "N/A"
          }}</span>

          <v-btn
            v-if="webHookService?.module_end_point"
            size="small"
            class="ml-3"
           variant="flat"
           color="primary"
            @click="copyEndpoint"
          >
            <v-icon size="small" color="white">mdi-content-copy</v-icon>
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <span><strong class="mr-1">Method:</strong> POST</span>
        </div>

        <div class="d-flex align-center">
          <strong>Inputs:</strong>
          <v-btn
            v-if="formattedJson"
            size="small"
            class="ml-5"
          variant="flat"
           color="primary"
            @click="copyInputs"
            style="position: relative; top: 3px; right: 13px"
          >
            <v-icon size="small" color="white">mdi-content-copy</v-icon>
          </v-btn>
        </div>

        <pre v-if="formattedJson" class="mt-2">{{ formattedJson }}</pre>
      </div>
    </v-card>

    <v-snackbar v-model="snackbar" color="green" location="top" :timeout="1500">
      Copied to clipboard!
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webHookService: "",
      webHookServiceItems: [],
      formattedJson: null,
      snackbar: false,
    };
  },

  watch: {
    webHookService(newValue) {
      this.formattedJson = newValue?.required_inputs
        ? JSON.stringify(newValue.required_inputs, null, 2)
        : null;
    },
  },

  mounted() {
    const serviceItems =
      this.$store.getters.get_current_user_details.organization_details
        .enabled_api_endpoints;
    
    serviceItems.forEach((serviceItem) => {
      const modifiedObj = {
        module_end_point: serviceItem.module_end_point,
        module_name: serviceItem?.module_name.replace(/_/g, " "),
        required_inputs: serviceItem.required_inputs,
      };
      this.webHookServiceItems.push(modifiedObj);
    });
    if (this.webHookServiceItems?.length > 0) {
      this.webHookService = this.webHookServiceItems[0];
    }
  },

  methods: {
    webHookCardEmit() {
      this.$emit("clicked");
    },

    copyEndpoint() {
      navigator.clipboard.writeText(this.webHookService.module_end_point);
      this.snackbar = true;
    },

    copyApiKey() {
      navigator.clipboard.writeText(
        this.$store.getters.get_current_user_details.organization_details
          .organization_api_key
      );
      this.snackbar = true;
    },

    copyInputs() {
      navigator.clipboard.writeText(this.formattedJson);
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
pre {
  color: #00ff88;
  white-space: pre-wrap;
  font-size: 14px;
}
</style>
